'use strict';
const BaseView = require('components-framework/view/base.view');
const withRenderedMain = require('components-framework/view/with_rendered_main');
const trackingUtils = require('od-modules/utils/tracking.utils');
const tagManagement= require('od-modules/utils/tag_management.utils');
const trackingPageFlowUtils = require('od-modules/utils/flow_tracking/tracking.page.flow.utils');
const trackFrontEventsUtils = require('od-modules/track_events/track.frontevents.utils');

const ANIMATION_CLASS_SHAKE = 'od-psd2-container-movement';
const trackingPageFlowAppearancesSettings = {
    trackingPageFlowAppearancesSettings: {
        flow: 'payment_flow_appearances',
        label: '3ds:ap',
    },
};

const isMobile = Odigeo.SessionScope.flow === 'mobile';

const beforeUnloadEvent = () => {
    setTimeout(function() {
        setTimeout(function() {
            trackingUtils.trackEvent('psd2_popup', 'psd2_warning_not-leave_click_cancel');
        }, 100);
    }, 1);
    return true;
};

function popStateCallBack(template) {
    window.onpopstate = () => window.history.pushState(null, document.title, location.href);
    const $template = this.$el.find(this.selectors[template]);
    trackingUtils.trackEvent('psd2_popup', `click_back_button_${template}`);
    $template
        .addClass(ANIMATION_CLASS_SHAKE)
        .on(Odigeo.Events.animationEnd, () => $template.removeClass(ANIMATION_CLASS_SHAKE));
}

module.exports = withRenderedMain(BaseView.extend({
    cons: {
        open: 'open',
    },
    selectors: {
        iframe3ds: '#iframe3ds',
        container: '.psd2_container',
        waiting: '.psd2_waiting',
        iframe: '.psd2_container',
        iframeContainer: '.iframe_container',
        psd2Content: '.psd2_content',
        drawerWrapper: '.psd2_drawer_wrapper',
        drawerBack: '.psd2_drawer_back',
        drawerCancelWrapper: '.psd2_drawer_cancel_wrapper',
        drawerCancelWrapperBg: '.psd2_drawer_cancel_wrapper_bg',
        drawerGeneric: '.psd2_drawer_generic',
        openInNewTab: '.transaction_not_complete',
        authenticationInfo: '.authentication_info',
    },
    trackingMap: {
        'iframe': 'authenticate_popup_shown',
        'drawer': 'authenticate_popup_shown',
        'dynamicMessage': 'connecting_popup_shown',
        'error': 'rejected_popup_shown',
        'creditCard': 'rejected_changecard_click',
        'otherMethod': 'rejected_otherpayment_click',
    },
    events: {
        'tap .psd2_close_btn': 'close',
        'tap .psd2_iframe_close_btn': 'closeIframe',
        'tap .psd2_error_close_btn': 'closeError',
        'tap .psd2_drawer_back': 'closeDrawer',
        'tap .cancel_authentication': 'cancelAuthentication',
        'tap .continue_authentication': 'continueAuthentication',
        'tap .transaction_not_complete span': 'onOpenNewTab',
    },
    isVisible: false,
    renderTemplate(templateName) {
        return this.templates[templateName]({
            keys: this.keys,
            prismaHeader: Odigeo.AB.prismaHeader,
            cssVariationMobile: Odigeo.AB.isCssVariationMobile,
            otherPaymentMethod: Odigeo._.find(this.model.get('paymentMethods'), (method) => method.method !== 'CREDITCARD'),
        });
    },
    toggleTemplate(template, isVisible, replace = !isMobile) {
        const $container = this.$el.find(this.selectors.container);
        const selectedPaymentMethod = this.model.get('selectedPaymentMethod');
        let content = '';

        if (isVisible) {
            trackingUtils.trackEvent('psd2_popup', this.trackingMap[template]);
            content = this.renderTemplate(template);
            Odigeo.trigger(this.id + ':psd2PopUpOpen');

            if (selectedPaymentMethod && selectedPaymentMethod.method === 'CREDITCARD') {
                this.avoidUserNavigation(template);
            }
        } else {
            Odigeo.trigger(this.id + ':psd2PopUpClosed');
            window.onbeforeunload = null;
            window.onpopstate = null;
        }

        if (replace) {
            $container.html(content);
        } else {
            $container.append(content);
        }
        $container.toggleClass(`${this.cons.open} od-psd2-popup-manager-box`, isVisible);
        this.blockScroll(isVisible);
        this.isVisible = isVisible;
        const event = `${this.id}:${template}${isVisible ? 'Shown' : 'Hidden'}`;
        Odigeo.trigger(event);
    },
    avoidUserNavigation(template) {
        window.onbeforeunload = beforeUnloadEvent;
        if (window.history.pushState && !this.model.get('forceBack')) {
            this.model.set('forceBack', true);
            window.history.pushState(null, document.title, location.href);
            window.onpopstate = popStateCallBack.bind(this, template);
        }
    },
    getIsVisible() {
        return this.isVisible;
    },
    resizeBox(cssClass, toggle) {
        this.$el.find(this.selectors.iframeContainer).toggleClass(cssClass, toggle);
    },
    showError() {
        const template = 'error';
        this.$el.find(this.selectors.waiting).addClass('odf-hidden');
        this.$el.find(this.selectors.container)
            .html(this.renderTemplate(template))
            .toggleClass(this.cons.open, true);
        trackingUtils.trackEvent('psd2_popup', this.trackingMap[template]);
        this.bindEvents();
        Odigeo.trigger(this.id + ':psd2PopUpOpen');
    },
    bindEvents() {
        this.$el.find('.psd2_retry_btn').off().on(Odigeo.Events.tap, Odigeo._.bind(this.retry, this, 'creditCard'));
        this.$el.find('.psd2_other_method_btn').off().on(Odigeo.Events.tap, Odigeo._.bind(this.retry, this, 'otherMethod'));
    },
    close() {
        this.toggleTemplate('waiting', false, true);
    },
    retry(method) {
        Odigeo.trigger(`${this.id}:${method}`);
        Odigeo.trigger(`${this.id}:retry`);
        trackingUtils.trackEvent('psd2_popup', this.trackingMap[method]);
    },
    removeConfirmInteractionData() {
        Odigeo.Session.remove('confirmInteractionNeededData');
    },
    closeIframe() {
        this.removeConfirmInteractionData();
        tagManagement.fireExternalEvent('qualtrics', 'closePsd2Iframe');
        Odigeo.trigger(`${this.id}:closeIframe`);
        this.close();
        trackingUtils.trackEvent('psd2_popup', 'authenticate_close_click');
    },
    closeError() {
        Odigeo.trigger(`${this.id}:closeError`);
        this.close();
        trackingUtils.trackEvent('psd2_popup', 'rejected_close_click');
    },
    blockScroll(isVisible) {
        if (isVisible) {
            $('body').addClass('odf-overflow-hidden');
        } else {
            $('body').removeClass('odf-overflow-hidden');
        }
    },
    toggleDrawer(open) {
        this.$el.find(this.selectors.drawerGeneric).toggleClass('odf-hidden', !open);
        this.$el.find(this.selectors.drawerWrapper).toggleClass('opened', open);
        if (!open) {
            setTimeout(() => {
                this.toggleTemplate('drawer', false, true);
            }, 500);
        } else {
            trackingUtils.trackPage('redirection-3dsecure');
            trackingUtils.trackEvent('psd2_popup', 'redirection-3dsecure');
        }
    },
    toggleAuthenticationConfirm(open) {
        this.$el.find(this.selectors.drawerCancelWrapperBg).toggleClass('odf-hidden', !open).toggleClass('opened', open);
        this.$el.find(this.selectors.drawerCancelWrapper).toggleClass('opened', open);
        if (open) {
            trackingUtils.trackEvent('psd2_popup', 'authenticate_cancel_warning_onload', '3dsecure_page');
        }
    },
    closeDrawer() {
        trackingUtils.trackEvent('psd2_popup', 'authenticate_cancel_click', '3dsecure_page');
        this.toggleAuthenticationConfirm(true);
    },
    cancelAuthentication() {
        this.removeConfirmInteractionData();
        trackingUtils.trackEvent('psd2_popup', 'authenticate_cancel_warning_click_change-pay-method', '3dsecure_page');
        this.toggleAuthenticationConfirm(false);
        this.toggleDrawer(false);
        tagManagement.fireExternalEvent('qualtrics', 'closePsd2Iframe');
    },
    continueAuthentication() {
        trackingUtils.trackEvent('psd2_popup', 'authenticate_cancel_warning_click_continue', '3dsecure_page');
        this.toggleAuthenticationConfirm(false);
    },
    toggleWaiting(isVisible) {
        this.toggleTemplate('dynamicMessage', isVisible, true);
        if (isVisible) {
            trackingPageFlowUtils.launchAppearancesTracking(trackingPageFlowAppearancesSettings);
        }
    },
    toggleIframeClasses(addClass) {
        this.$el.find(this.selectors.iframe3ds).toggleClass('odf-hidden od-force-hide-iframe', addClass);
        this.$el.find(this.selectors.psd2Content).toggleClass('odf-hidden', addClass);
        this.$el.find(this.selectors.container).toggleClass(`${this.cons.open} od-psd2-popup-manager-box`, true);
    },
    showIframe3ds() {
        if (isMobile) {
            setTimeout(() => {
                this.$el.find(this.selectors.waiting).addClass('odf-hidden');
                this.toggleIframeClasses(false);
            }, 5000);
        } else {
            trackFrontEventsUtils.trackJQElementDisplayed(this.$el.find(this.selectors.iframe3ds));
            this.toggleIframeClasses(false);
        }
    },
    onOpenNewTab() {
        window.onbeforeunload = null;
        trackingUtils.trackEvent('psd2_popup', 'authenticate_transaction-not-completed_click:re-direct', '3dsecure_page');
        Odigeo.trigger(`${this.id}:openBankPageNewTab`);
    },
}));
